import FileSaver from 'file-saver';
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { FaDownload } from 'react-icons/fa';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useCurrentPng } from 'recharts-to-png';

function PortPlot({ portData, showPortPlot, setShowPortPlot, fuelTypeInfo, overallFueltypes }) {
    const [dtgs, setDtgs] = useState()

    useEffect(() => {
        let _dtgs = portData.map(d => { return (`${d.year}-${d.month}`) })
        setDtgs(_dtgs)
    }
        , [portData])

    const getConsumptionData = (d) => {
        let fdata = d.map(f => { return { ...f, name: (f.month - 1 < 0.1) ? f.year : f.month } })
        return fdata
    }
    const getXticks = (d) => {

        return d.filter(a => a.month - 1 < 0.1)
            .map(a => a.year)

    }
    const CustomTooltipFuel = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{
                    backgroundColor: 'white', border: '1px solid darkgray',
                    borderRadius: '10px', padding: '10px'
                }}>
                    <Row>
                        <Col style={{ fontSize: 10 }}><b>{dtgs[parseInt(label)]}</b></Col>
                    </Row>

                    {payload.filter(p => p.value > 0).sort((a, b) => b.value - a.value).map((p, idx) =>
                        <Row key={`pptt${idx}`}>
                            <Col style={{ fontSize: 10 }}>{`${p.name} : ${p.value.toFixed(0)}`}</Col>
                        </Row>)
                    }
                </div>
            );
        }
    }

    const [getPNG, { ref }] = useCurrentPng();
    const handleDownload = useCallback(async () => {
        const png = await getPNG();
        if (png) {
            FileSaver.saveAs(png, `${portData[0].name}.png`);
        }
    }, [getPNG, portData]);
    return (
        <Modal show={showPortPlot} size="xl" centered>
            <Modal.Header closeButton onHide={() => setShowPortPlot(false)}>
                <Modal.Title className='d-flex gap-3 align-items-center' >Bunker quantities {portData[0].name} [MWh]
                <FaDownload onClick={handleDownload} size="0.6em" style={{cursor: 'pointer'}}/>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ResponsiveContainer width="100%" height={250}>
                    <AreaChart
                        data={getConsumptionData(portData)}
                        syncId="anyId"
                        margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 5,
                        }}
                        ref={ref}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" ticks={getXticks(portData)} />
                        <YAxis />
                        <Legend verticalAlign="top" align="right" height={36} />
                        <Tooltip content={<CustomTooltipFuel />} />
                        {
                            overallFueltypes.map(a => <Area key={a.name} dataKey={a.name} name={fuelTypeInfo[a.name].short_display_name} stackId="1"
                                stroke={fuelTypeInfo[a.name].color_name} fill={fuelTypeInfo[a.name].color_name} />)
                        }
                    </AreaChart>
                </ResponsiveContainer>
            </Modal.Body>
        </Modal>
    )
}

export default PortPlot